/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '../routers'
import { requestConfig } from '@/api/index.js'
import { getBaseToken, getToken, removeBaseToken } from '@/axios/cookies.js'
import { clearUserInfo, clearUserSession, getStoredUserInfo, hasUserIdentity } from '@/utils/auth'

const service = axios.create({
  baseURL: requestConfig.url,
  timeout: requestConfig.timeout
})

let logout = false

function handleUnauthorized (response) {
  const authType = response && response.config && response.config.__authType
  if (authType === 'base') {
    removeBaseToken()
    return
  }

  if (logout) return
  logout = true
  clearUserSession()
  Vue.prototype.$message({
    message: '请先登录',
    onClose: () => {
      logout = false
    }
  })
  if (router.currentRoute.path !== '/login') {
    router.push('/login')
  }
}

service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'

    const userToken = getToken()
    if (!userToken && (hasUserIdentity(getStoredUserInfo()) || hasUserIdentity(store.getters.userInfo))) {
      clearUserInfo()
    }

    const requestToken = userToken || getBaseToken()
    config.__authType = userToken ? 'user' : requestToken ? 'base' : 'none'
    if (requestToken) {
      config.headers.Authorization = 'Bearer ' + requestToken
    }
    return config
  },
  error => {
    console.error(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res && res.status === 401) {
      handleUnauthorized(response)
    }
    return res
  },
  error => {
    if (error && error.response) {
      console.log('请求失败', error.response.status)
      if (error.response.status === 401) {
        handleUnauthorized(error.response)
      }
    } else {
      console.error('请求失败', error)
    }
    return Promise.reject(error)
  }
)

export default service
